import { z } from 'zod';

/** Shared across routes so header `?search=` survives navigation. */
export const globalSearchSchema = z.object({
  search: z.string().optional(),
});

export type GlobalSearch = z.infer<typeof globalSearchSchema>;

export function withGlobalSearch<T extends z.ZodRawShape>(shape: T) {
  return globalSearchSchema.extend(shape);
}
